import {
  Box,
  Button,
  CardMedia,
  Dialog,
  Divider,
  Grid,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  MenuList,
  Stack,
  Step,
  StepButton,
  StepConnector,
  StepLabel,
  Stepper,
  Typography,
  stepConnectorClasses,
  useTheme,
  Theme,
  StepIcon,
  StepIconProps
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Link, useHistory, useRouteMatch } from 'react-router-dom';
import { useEffect, useState } from 'react';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  APPLICATION_TYPE,
  DOCUMENT_UPLOAD_DOWNLOAD_APPLICATION,
  NEXEDGE_INVESTMENT_PREFERENCE,
  ONBOARDING_DEMAT_DETAILS,
  USER_ROLES,
} from '../../utils/constant';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../redux-store/reducers';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useFormikContext } from '../../lib/formik/Formik';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';
import { InfoIconFilled, StepperSuccessIcon } from '../../assets/SvgIcons';
import BreadCrum from '../../lib/BreadCrum';
import { ApplicationDownload } from '../../redux-store/actions/onBoarding';
import { reportDownload } from '../Reports/report-utils';
import { useSnackbar } from 'notistack';
import { isModuleAllowed } from '../../utils/utilityFunctions';
import { BootstrapStepConnector } from '../StepperLoading';


// Investor Details Layout
const MenuItemList = [
  'RM Details',
  'Personal Details',
  'Details of Related Person',
  'Contact Details',
  'Additional KYC Details',
  'Nominee Details',
  'FATCA Declaration',
  'Bank Details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['DP Details'] : []),
  'Risk Profiles',
  'Investment Preference',
  ...(!NEXEDGE_INVESTMENT_PREFERENCE ? ['Service Preference'] : []),
  'Upload Documents',
];

const HeaderList = [
  'RM Details',
  'Personal Details',
  'Details of Related Person',
  'Contact Details',
  'Additional KYC Details',
  'Nominee Details',
  'FATCA Declaration',
  'Bank Details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['DP Details'] : []),
  'Risk Profiles',
  'Investment Preference',
  ...(!NEXEDGE_INVESTMENT_PREFERENCE ? ['Service Preference'] : []),
  'Upload Documents',
];
const MenuItemListLink = [
  'rm-details',
  'personal-details',
  'related-person-details',
  'contact-details',
  'additional-KYC-details',
  'nominee-details',
  'fatca',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ['dp-details'] : []),
  'risk-profiles',
  'investment-preference',
  ...(!NEXEDGE_INVESTMENT_PREFERENCE ? ['service-preference'] : []),
  'document-details',
];

const NonIndividualMenuItemList = [
  'Distributor Details',
  'Contributor Details',
  'Contact Details',
  "Investor's Bank Details",
  ...(ONBOARDING_DEMAT_DETAILS ? ["Investor's DP Details"] : []),
  'Related Parties',
  'FATCA',
  'Risk Profile',
  'Investment Preference',
  'Document Details'
];

const NonIndividualHeaderList = [
  'Distributor Details',
  'Contributor Details',
  'Contact Details',
  "Investor's Bank Details",
  ...(ONBOARDING_DEMAT_DETAILS ? ["Investor's DP Details"] : []),
  'Related Parties',
  'FATCA',
  'Risk Profile',
  'Investment Preference',
  'Document Details',
];

const NonIndividualMenuItemListLink = [
  'distributor-details',
  'personal-details',
  'contact-details',
  'bank-details',
  ...(ONBOARDING_DEMAT_DETAILS ? ["dp-details"] : []),
  'related-parties',
  'fatca',
  'risk-profile',
  'investment-preference',
  'document-details',
];

const breadCrumbNameMapping: Record<string, string | Record<string, string>> = {
  "rm details": "RM Details",
  "personal details": {
    "/application/personal-details": "Personal Details",
    "/non-individual-application/personal-details": "Contributor Details"
  },
  "related person details": "Details of Related Person",
  "contact details": "Contact Details",
  "additional kyc details": "Additional KYC Details",
  "nominee details": "Nominee Details",
  "fatca": {
    "/application/fatca": "FATCA Declaration",
    "/non-individual-application/fatca": "FATCA"
  },
  "bank details": {
    "/application/bank-details": "Bank Details",
    "/non-individual-application/bank-details": "Investor's Bank Details"
  },
  "dp details": {
    "/application/dp-details": "DP Details",
    "/non-individual-application/dp-details": "Investor's DP Details"
  },
  "risk profiles": "Risk Profiles",
  "investment preference": "Investment Preference",
  "service preference": "Service Preference",
  "document details": {
    "/application/document-details": "Upload Documents",
    "/non-individual-application/document-details": "Document Details"
  },
  "distributor details": "Distributor Details",
  "related parties": "Related Parties",
  "declaration ubo": "Declaration of UBO",
  "risk profile": "Risk Profile"
};

export const InvestorDetailsLayout = ({
  applicationId,
  applicationNumber = '',
  applicant1ReferenceId = '',
  children,
}: {
  applicationId: string;
  applicationNumber: string;
  applicant1ReferenceId?: string;
  children: JSX.Element;
}): JSX.Element => {
  const theme = useTheme()

  const { application } = useSelector((store: RootStateType) => store.application);
  const { currentStep } = application || {};
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isApplicationDownloading, setApplicationDownloadStatus] = useState<boolean>(false)
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const { path } = useRouteMatch();
  const history = useHistory();
  const [transitionClassName, setTransitionClassName] = useState('');
  const { role = '', permissions = [] } = useSelector((store: RootStateType) => store.auth);
  const result = useRouteMatch<{ slug: string }>({
    path: `${path}/:slug/`,
  });
  const activeItem = result
    ? application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? NonIndividualMenuItemListLink.indexOf(result.params.slug)
      : MenuItemListLink.indexOf(result.params.slug)
    : 0;
  const menuList =
    application &&
    (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? NonIndividualMenuItemList
      : MenuItemList);
  useEffect(() => {
    window.scrollTo(0, 0);
    setTransitionClassName('slideInUp');
    const timeoutId = setTimeout(() => {
      setTransitionClassName('');
    }, 300);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [activeItem]);

  const initialRouter = history.location.pathname?.split('/').filter((item) => item !== '')

  // const routerText = initialRouter[1]?.split('-').join(' ')

  const routerPath = (isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? [
    {
      name: 'Dashboard',
      path: '/dashboard',
      warning: true
    },
    {
      name: 'Onboarding investor',
      path: `/onboarding`,
    },
    {
      name: initialRouter[1]?.split('-').join(' '),
      path: `/${initialRouter[0]}/${initialRouter[1]}`,
      textSx: {
        textTransform: 'none'
      }
    },
  ] : [])

  const modifiedRouterPath = routerPath.map(obj => {
    const lowerCaseName = obj?.name?.toLowerCase();
    const lowerCasePath = obj?.path?.toLowerCase();

    if (breadCrumbNameMapping[lowerCaseName]) {
      const mappedValue = breadCrumbNameMapping[lowerCaseName];

      if (typeof mappedValue === 'object' && mappedValue[lowerCasePath]) {
        return { ...obj, name: mappedValue[lowerCasePath], isTextLowerCase: false };
      } else if (typeof mappedValue === 'string') {
        return { ...obj, name: mappedValue, isTextLowerCase: false };
      }
    }

    return obj;
  });

  const handleApplicationDownload = async () => {
    try {
      setApplicationDownloadStatus(true)

      const applicationDownloadRes = (await dispatch(ApplicationDownload(applicationId ?? ""))) as unknown as any;

      reportDownload(applicationDownloadRes as unknown as Blob, `${applicationId ?? ""}.pdf`);

      enqueueSnackbar('Downloaded successfully', {
        variant: 'success',
        autoHideDuration: 3000,
      });
    } catch (error) {
      console.log(error)
    } finally {
      setApplicationDownloadStatus(false)
    }
  }

  const isDiyInvestorOnboarding = path?.includes("/investor-onboarding-application")
  const defaultActiveStep = isDiyInvestorOnboarding ? 1 : 0

  return (
    <>
      <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center', mb: 2 }}>
        <IconButton
          aria-labelledby="mobile-back-button-label"
          onClick={() =>
            history.push(
              role === USER_ROLES.INVESTOR
                ? `/investment-details/${applicant1ReferenceId}/application-details`
                : [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
                  ? `/application-details/${applicationId}`
                  : '/applications'
            )
          }>
          <ArrowBackIosRoundedIcon fontSize="small" aria-hidden="true" />
        </IconButton>
        <Typography
          id="mobile-back-button-label"
          sx={{ fontWeight: 500, fontFamily: `${theme.typography.fontFamily}` }}
        >
          Back
        </Typography>
      </Box>
      {/* Mobile dropdown */}
      <Box sx={{ display: { xs: 'block', md: 'none' }, mx: -2 }}>
        <Button
          variant="text"
          fullWidth
          id="application-button"
          aria-controls="application-dropdown"
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          startIcon={<CardMedia component="img" src="/images/person.svg" alt="Icon" />}
          endIcon={<ExpandMoreIcon />}
          sx={{
            color: 'text.primary',
            bgcolor: '#F7FAFD',
            px: 2,
            justifyContent: 'flex-start',
            textAlign: 'left',
            borderBottom: '1px solid #E8E8E8',
            borderRadius: 0,
            '.MuiButton-endIcon': {
              ml: 'auto',
            },
          }}>
          <Box>
            <Typography variant="body2">
              Page {activeItem + 1}/{' '}
              {application &&
                (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                  ? NonIndividualHeaderList.length
                  : HeaderList.length)}
            </Typography>
            <Typography sx={{ fontWeight: 500 }}>
              {application &&
                (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                  ? NonIndividualHeaderList[activeItem]
                  : HeaderList[activeItem])}
            </Typography>
          </Box>
        </Button>
        <Menu
          id="application-dropdown"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'application-button',
          }}
          sx={{
            '.MuiPaper-root ': {
              width: '100%',
              bgcolor: '#F7FAFD',
              '.MuiList-root': {
                p: 0,
                '.MuiDivider-root': { m: 0 },
                '.MuiMenuItem-root': {
                  '.MuiListItemText-primary': {
                    fontWeight: 500,
                    fontSize: 14,
                  },
                  [`:nth-of-type(${activeItem + 1})`]: {
                    '.MuiListItemText-primary': {
                      fontWeight: 600,
                      color: 'primary.main',
                    },
                  },
                },
              },
            },
          }}>
          {menuList &&
            menuList.map((item, index: number) => {
              const isItemDisabled = !currentStep ? index !== 0 : index > currentStep;
              const isRmDetailsClickable = index === 0 ? !isDiyInvestorOnboarding : true

              return (
                <>
                  <MenuItem
                    key={index}
                    onClick={() => {
                      setAnchorEl(null);
                      history.push(
                        `${application &&
                        (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                          ? NonIndividualMenuItemListLink[index]
                          : MenuItemListLink[index])
                        }`,
                        {
                          id: applicationId,
                          applicant1ReferenceId,
                        }
                      );
                    }}
                    sx={{ minHeight: '30px' }}
                    disabled={isItemDisabled || !isRmDetailsClickable}>
                    <ListItemText
                      sx={{
                        color: isItemDisabled || currentStep === index ? '#575757' : '#57B6BA',
                        opacity: isItemDisabled ? 0.5 : 1,
                      }}>
                      {item}
                    </ListItemText>
                    <ArrowForwardIcon sx={{ color: '#00D9DA' }} />
                  </MenuItem>
                  <Divider />
                </>
              );
            })}
        </Menu>
      </Box>
      {/* Mobile dropdown End */}
      <Box
        sx={{
          display: { xs: 'none', md: 'flex' },
          alignItems: 'center',
          justifyContent: 'space-between',
          // p: '10px 20px',
          py: "10px",
          // mb: 2,
          // bgcolor: '#e5f1f8',
          // borderRadius: '10px',
          // zIndex: 10,
          // position: 'sticky',
          // top: '63px',
        }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* {[USER_ROLES.AMCAPPROVER].includes(role) ? ( */}
          {!isModuleAllowed({ value: "MFDashboard", compareArr: permissions, objKey: "permissonCode" }) ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <IconButton
                sx={{ height: 'fit-content', p: 0 }}
                // component={Link}
                // to="/applications-list"
                onClick={() => history.push(`/application-details/${applicationId}`)}
              // disabled={approveLoading || rejectLoading}
              >
                <NavigateBeforeIcon fontSize="large" sx={{ color: 'common.black' }} />
              </IconButton>
              <Typography sx={{ fontSize: 20, fontWeight: 600 }}>
                Application
              </Typography>
            </Box>
          ) : (!isDiyInvestorOnboarding ?
            <BreadCrum array={modifiedRouterPath} /> : null
          )}
          {/* <IconButton
            sx={{
              // height: 'fit-content', 
              height: "18px",
              p: 0
            }}
            onClick={() =>
              history.push(
                role === USER_ROLES.INVESTOR
                  ? `/investment-details/${applicant1ReferenceId}/application-details`
                  : [USER_ROLES.AMCAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
                    ? `/application-details/${applicationId}`
                    : '/applications'
              )
            }>
            <NavigateBeforeIcon fontSize="small" sx={{ color: 'text.secondary' }} />
          </IconButton>
          <Typography
            // sx={{
            //   fontSize: 20,
            //   fontWeight: 600,
            //   color: '#1C2D47',
            // }}
            variant='subtitle_500'
            color="text.secondary"
          >
            {application &&
              (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                ? [USER_ROLES.AMCAPPROVER].includes(role)
                  ? 'Edit Application'
                  : 'Non Individual Investor Onboarding'
                : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER, USER_ROLES.AMCAPPROVER].includes(
                  role
                )
                  ? 'Edit Application'
                  : 'Individual Investor Onboarding')}
          </Typography> */}
        </Box>
        <Typography sx={{ fontWeight: 600, letterSpacing: '1px' }}></Typography>
        {/* {!!applicationNumber && (
          <Typography
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontWeight: 500,
              fontSize: '16px',
              color: '#1C2D47',
              opacity: 0.7,
            }}>
            Application ID: {applicationNumber}
          </Typography>
        )} */}
      </Box>
      <Box sx={{
        display: "flex",
        mt: { xs: "15px", md: 0 },
        mb: "25px",
        alignItems: 'center',
        justifyContent: 'space-between',
      }} >


        <Typography
          variant='h1'
          color="text.primary"
          sx={{ ...([USER_ROLES.AMCAPPROVER].includes(role) ? { marginLeft: "35px" } : {}) }}
        >
          {application?.onboardingType?.toLowerCase() === "minor" ?
            `Minor Investor Onboarding ${application?.accountType ? '(' + application?.accountType + ')' : ''}` :
            ""
          }
          {(application?.onboardingType?.toLowerCase() === "normal" &&
            application?.applicationType === APPLICATION_TYPE.INDIVIDUAL) ?
            `Individual Investor Onboarding ${application?.accountType ?
              '(' + application?.accountType + ')' : ''}` :
            ""
          }
          {(application?.onboardingType?.toLowerCase() === "normal" &&
            application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL) ?
            `Non Individual Investor Onboarding ${application?.accountType ?
              '(' + application?.accountType + ')' : ''}` :
            ""
          }
        </Typography>
        {!!applicationNumber && (
          <Typography
            variant='body_500'
            color="text.primary"
          >
            Application ID: {applicationNumber}
          </Typography>
        )}
      </Box >
      <Box
        sx={{
          // py:1,
          // bgcolor: 'white',
          // boxShadow: { xs: '', md: '0px 4px 12px rgba(0, 0, 0, 0.05)' },
          // borderRadius: '10px',
          // height: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 165px)' },
          // overflowY: 'auto',
          minHeight: { xs: 'calc(100vh - 100px)', md: 'calc(100vh - 195px)' },
          boxShadow: `0px 4px 10px 0px ${theme.palette.common.black}0D`,
          bgcolor: "background.paper",
          borderRadius: "25px",
          // p: "25px",
          p: { sm: "25px", xs: '0px' },
        }}>
        <Box>
          <Grid
            container
            sx={
              {
                // height: { xs: '', md: 'calc(100vh - 200px)' },
                // overflowY: 'scroll',
                // '::-webkit-scrollbar': {
                //   display: 'none',
                // },
              }
            }
          >
            <Grid
              item
              md={6}
              lg={3}
              sx={{
                display: { xs: 'none', md: 'flex' },
                // backgroundColor: 'rgba(51, 127, 201, 0.025)',
              }}>
              <Stack sx={{ position: 'sticky', top: '0', pl: 4, py: 3, height: 'calc(100vh - 108px)' }}>
                {/* <MenuList>
                  {menuList &&
                    menuList.map((item, index) => {
                      const isItemDisabled = !currentStep ? index !== 0 : index > currentStep;
                      return (
                        <MenuItem
                          key={index}
                          // component={RouterLink}
                          // to={`${MenuItemListLink[index]}`}
                          onClick={() =>
                            history.push(
                              `${application &&
                              (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                                ? NonIndividualMenuItemListLink[index]
                                : MenuItemListLink[index])
                              }`,
                              {
                                id: applicationId,
                                applicant1ReferenceId,
                              }
                            )
                          }
                          disabled={isItemDisabled}
                          sx={{
                            color: isItemDisabled || currentStep === index ? '#575757' : '#57B6BA',
                            opacity: isItemDisabled ? 0.5 : 1,
                            fontSize: 14,
                            fontWeight: 500,
                            my: 1,
                            whiteSpace: 'break-spaces',
                            justifyContent: 'flex-end',
                            textAlign: 'right',
                            ':hover': {
                              background:
                                'linear-gradient(88.93deg, rgba(51, 127, 201, 0.0875) 10.58%, rgba(51, 127, 201, 0.025) 93.37%)',
                            },
                            [`:nth-of-type(${activeItem + 1})`]: {
                              fontWeight: 600,
                              color: 'primary.main',
                              background:
                                'linear-gradient(88.93deg, rgba(51, 127, 201, 0.0875) 10.58%, rgba(51, 127, 201, 0.025) 93.37%)',
                              '&:after': {
                                content: '""',
                                position: 'absolute',
                                top: '0',
                                right: '0',
                                width: '4px',
                                height: '100%',
                                bgcolor: 'primary.main',
                                borderRadius: '5px',
                              },
                            },
                          }}>
                          {item}
                        </MenuItem>
                      );
                    })}
                </MenuList> */}
                <Stepper
                  activeStep={currentStep ?? defaultActiveStep}
                  orientation="vertical"
                  connector={<BootstrapStepConnector />}
                  sx={{
                    "&.MuiStepper-vertical": {
                      ".MuiStepButton-vertical": {
                        ".MuiStepLabel-vertical": {
                          paddingTop: "0px",
                          paddingBottom: "0px"
                        }
                      }
                    }
                  }}
                >
                  {menuList &&
                    menuList.map((item, index) => {
                      const isItemDisabled = !currentStep ? index !== 0 : index > currentStep;
                      const isRmDetailsClickable = index === 0 ? !isDiyInvestorOnboarding : true

                      return <Step key={index}>
                        <StepButton
                          onClick={() => !isItemDisabled &&
                            isRmDetailsClickable &&
                            history.push(
                              `${application &&
                              (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                                ? NonIndividualMenuItemListLink[index]
                                : MenuItemListLink[index])
                              }`,
                              {
                                id: applicationId,
                                applicant1ReferenceId,
                              }
                            )
                          }
                          disabled={isItemDisabled || !isRmDetailsClickable}
                        >
                          <StepLabel
                            sx={(theme: Theme) => ({
                              "& .MuiStepLabel-label.Mui-completed": {
                                ...theme.typography.body_500,
                                color: activeItem === index ? theme.palette.grey[600] : theme.palette.text.secondary,
                              },
                              "& .MuiStepLabel-label.Mui-active": {
                                ...theme.typography.body_500,
                                color: theme.palette.primary[500]
                              },
                              "& .MuiStepLabel-label.Mui-disabled": {
                                ...theme.typography.body_500,
                                color: theme.palette.text.secondary,
                              },
                              "& .MuiStepLabel-iconContainer.Mui-active": {
                                "& .MuiStepIcon-root": {
                                  color: theme.palette.primary[500]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.textDark.primary
                                }
                              },
                              "& .MuiStepLabel-iconContainer.Mui-completed": {
                                "& .MuiStepIcon-root": {
                                  color: theme.palette.grey[600]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.common.white
                                }
                              },
                              "& .MuiStepLabel-iconContainer.Mui-disabled": {
                                "& .MuiStepIcon-root": {
                                  color: theme.palette.grey[100]
                                },
                                "& .MuiStepIcon-text": {
                                  ...theme.typography.subtitle_500,
                                  fill: theme.palette.text.secondary
                                }
                              }
                            })}
                            StepIconComponent={({ completed, ...props }: StepIconProps) => <StepIcon {...props} icon={completed ?
                              activeItem === index ?
                                activeItem + 1
                                : <StepperSuccessIcon />
                              : props.icon} />}
                          >
                            {item}
                          </StepLabel>
                        </StepButton>
                      </Step>
                    })}
                </Stepper>
              </Stack>
            </Grid>
            <Grid
              item
              container
              xs={12}
              md={6}
              lg={9}
              sx={(theme: Theme) => ({
                p: "35px",
                border: `1px solid ${theme.palette.text.secondary}26`,
                borderRadius: "15px",
              })}
              className={transitionClassName}
            >
              {/* <Grid item xs={12} md={1} sx={{ display: { xs: 'none', md: 'block' } }} /> */}
              {/* <Grid item xs={12}> */}
              {/* <Box sx={{ px: { xs: 1, md: 'unset' } }} className={transitionClassName}> */}
              <Grid item xs={12}>
                <Grid container alignItems="center" mb={3}>
                  <Grid item xs={6}>
                    <Typography
                      component="h3"
                      variant="h2"
                      sx={{
                        // fontFamily: 'Poppins, sans-serif',
                        // fontSize: 25,
                        // fontWeight: 500,
                        // color: '#0D2762',
                        color: "text.primary"
                      }}>
                      {application &&
                        (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
                          ? NonIndividualHeaderList[activeItem]
                          : HeaderList[activeItem])}
                    </Typography>
                  </Grid>
                  {(
                    DOCUMENT_UPLOAD_DOWNLOAD_APPLICATION &&
                    application &&
                    (
                      (application.applicationType === APPLICATION_TYPE.INDIVIDUAL && HeaderList[activeItem] === "Upload Documents") ||
                      (application.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL && NonIndividualHeaderList[activeItem] === "Document Details")
                    )
                  ) && (
                      <Grid item container xs={6} justifyContent="flex-end">
                        <LoadingButton
                          loadingPosition="center"
                          loading={isApplicationDownloading}
                          variant="contained"
                          onClick={handleApplicationDownload}
                          sx={(theme) => ({
                            ...theme.typography.body_500,
                            padding: "5px 10px",
                            borderRadius: "10px",
                            color: theme.palette.common.white,
                            fontWeight: 600
                          })}
                        >
                          Download Application
                        </LoadingButton>
                      </Grid>
                    )}
                </Grid>
                {children}
              </Grid>
              {/* </Box> */}
              {/* </Grid> */}
              {/* <Grid item xs={12} md={1} sx={{ display: { xs: 'none', md: 'block' } }} /> */}
            </Grid>
          </Grid>
        </Box>
      </Box >
    </>
  );
};
// Investor Details Layout End

export const SubHeading = styled('h3')(({ theme }) => ({
  // backgroundColor: 'rgba(221, 234, 243, 0.34)',
  backgroundColor: theme.palette.primary[50],
  // color: theme.palette.primary.main,
  color: theme.palette.primary[900],
  // fontSize: '14px',
  // fontWeight: 600,
  ...theme.typography.body_500,
  // borderRadius: '5px',
  borderRadius: "10px",
  width: '100%',
  // letterSpacing: '1px',
  // letterSpacing: "2%",
  // marginLeft: '40px',
  // marginTop: '30px',
  // padding: '10px 30px',
  padding: "15px",
  // [theme.breakpoints.down('md')]: {
  // padding: '10px 20px',
  // padding: "15px"
  // },
  // [theme.breakpoints.down('md')]: {
  //   textAlign: 'center',
  // },
}));

export const ProceedSaveLater = ({
  saveLater,
  saveAndProceed,
  loader,
  clickedButton,
  saveButtonText = 'Save and Proceed',
  saveAndProceedType = 'submit',
  showEndIcon = true,
  showSaveForLater = true,
  disabled,
}: {
  saveLater?: () => void;
  saveAndProceed?: () => void;
  loader?: boolean;
  clickedButton?: string;
  saveAndProceedType?: 'button' | 'submit' | 'reset' | undefined;
  saveButtonText?: string;
  showEndIcon?: boolean;
  showSaveForLater?: boolean;
  disabled?: boolean;
}): JSX.Element => {
  return (
    // <Grid
    //   container
    //   sx={{
    //     // width: '100%',
    //     // mx: 'auto',
    //     // mt: 5,
    //     // display: 'flex',
    //     // flexWrap: 'wrap',
    //     // gap: 3,
    //     // justifyContent: 'center',
    //     // '.MuiButton-root': {
    //     //   fontSize: 14,
    //     //   fontWeight: 500,
    //     //   lineHeight: 1.5,
    //     // },
    //   }}
    // >
    <>
      {showSaveForLater && (
        <Grid
          item
          xs={12}
          lg={6}>
          <LoadingButton
            loadingPosition="start"
            type="submit"
            onClick={saveLater}
            loading={clickedButton === 'save for later' ? loader : false}
            fullWidth
            sx={(theme: Theme) => ({
              backgroundColor: "transparent",
              color: theme.palette.text.secondary,
              // border: '1px dashed #AAB2BA',
              border: `0.5px solid ${theme.palette.text.secondary}`,
              // maxWidth: '165px',
              borderRadius: "10px",
              padding: "10px",
              "&:hover, &.Mui-focusVisible": {
                borderColor: theme.palette.text.secondary,
                backgroundColor: theme.palette.background.default
              }
            })}
            disabled={disabled ? disabled : loader}>
            Save for later
          </LoadingButton>
        </Grid>
      )
      }
      <Grid
        item
        xs={12}
        lg={6}
        mt={{ xs: 2, lg: 0 }}
      >
        <LoadingButton
          loadingPosition="start"
          type={saveAndProceedType}
          loading={clickedButton === 'save and proceed' ? loader : false}
          variant="contained"
          fullWidth
          onClick={saveAndProceed}
          endIcon={showEndIcon && <KeyboardArrowRightSharpIcon />}
          // sx={{ maxWidth: { xs: '170px', sm: '220px' } }}
          sx={(theme) => ({
            padding: "10px",
            borderRadius: "10px",
            backgroundColor: theme.palette.primary[500],
            color: theme.palette.textDark.primary
          })}
          disabled={disabled ? disabled : loader}>
          {saveButtonText}
        </LoadingButton>
      </Grid>
    </>
    // </Grid >
  );
};

export const Notes = ({
  displayContent,
  displayContent1 = '',
  showIcon = true,
  icon
}: {
  displayContent: string;
  displayContent1?: string;
  showIcon?: boolean
  icon?: JSX.Element
}): JSX.Element => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: 'flex-start',
        borderRadius: "10px",
        backgroundColor: "grey.100",
        p: "14px",
        columnGap: "10px",
      }}
    >
      {showIcon &&
        <Box
          aria-hidden="true"
          sx={{ display: "flex", flexShrink: 0 }}
        >
          {icon || <InfoIconFilled />}
        </Box>}
      <Box>
        <Typography variant='body_400' color="text.secondary" sx={{ lineHeight: "17.5px" }}>{displayContent}</Typography>
        {displayContent1 &&
          <Typography variant='body_400' color="text.secondary" sx={{ lineHeight: "17.5px", mt: "10px" }}>{displayContent1}</Typography>
        }
      </Box>
    </Box >
    // <Typography
    //   component="div"
    //   sx={{
    //     backgroundColor: 'rgba(51, 127, 201, 0.04)',
    //     display: 'flex',
    //     flexDirection: 'row',
    //     padding: '10px 20px',
    //     borderRadius: '5px',
    //     alignItems: 'flex-start',
    //     mt: 0.5,
    //     mb: 1,
    //     width: '100%',
    //     boxSizing: 'border-box',
    //   }}>
    //   {/* <InfoOutlinedIcon color="info" fontSize="small" /> */}
    //   <InfoIcon stroke="#6c737f" />
    //   <Typography
    //     sx={{
    //       color: 'rgba(41, 49, 57, 0.7)',
    //       fontSize: '13px',
    //       fontWeight: 500,
    //       ml: 1,
    //     }}>
    //     <Typography
    //       sx={{
    //         color: 'rgba(41, 49, 57, 0.7)',
    //         fontSize: '13px',
    //         fontWeight: 500,
    //         ml: 1,
    //       }}>
    //       {displayContent}
    //     </Typography>
    //     {displayContent1 && (
    //       <Typography
    //         sx={{
    //           color: 'rgba(41, 49, 57, 0.7)',
    //           fontSize: '13px',
    //           fontWeight: 500,
    //           ml: 1,
    //           mt: 0.5,
    //         }}>
    //         {displayContent1}
    //       </Typography>
    //     )}
    //   </Typography>
    // </Typography>
  );
};

export const InfoDialog = ({
  onClose,
  open,
  content,
}: {
  onClose: any;
  open: any;
  content: string;
}): JSX.Element => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{
        '.MuiPaper-root ': {
          maxWidth: 400,
          p: { xs: 2, sm: '15px 20px 45px' },
          borderRadius: '10px',
          height: 'unset',
          overflowY: 'auto',
        },
      }}>
      <IconButton onClick={onClose} sx={{ alignSelf: 'flex-end' }}>
        <CloseIcon fontSize="medium" />
      </IconButton>
      <Box sx={{ mb: 2, textAlign: 'center', '.MuiSvgIcon-root': { fontSize: '3.1875rem' } }}>
        <InfoOutlinedIcon color="info" fontSize="large" />
      </Box>
      <Box
        sx={{
          width: { xs: '100%', sm: '80%' },
          mx: 'auto',
          '.MuiTypography-root': {
            fontSize: 20,
            fontWeight: 500,
            textAlign: 'center',
          },
        }}>
        <Typography sx={{ color: 'secondary.main', lineHeight: '35px' }}>{content}</Typography>
      </Box>
    </Dialog>
  );
};
